import * as Sentry from '@sentry/browser'

export const setTag = (key: string, value: string) => Sentry.setTag(key, value)
export const setUser = (id: string, email: string) => Sentry.setUser({ id, email })
export const captureError = (error: Error) => Sentry.captureException(error)

interface TSentryTag {
  key: string
  value: string
}

export interface TCaptureException {
  /// https://docs.sentry.io/platforms/javascript/enriching-events/tags/
  /// Tags provide additional context to events. They are key-value pairs that can be used to filter events.
  tags?: TSentryTag[]
  /// https://docs.sentry.io/platforms/javascript/enriching-events/identify-user/
  user?: Record<string, string>
  /// https://docs.sentry.io/platforms/javascript/enriching-events/context/
  context?: Record<string, string>
  /// https://docs.sentry.io/platforms/javascript/usage/sdk-fingerprinting/
  /// Forces grouping: events sharing a fingerprint collapse into one issue.
  fingerprint?: string[]
}

export const captureException = (error: Error, options?: TCaptureException) => {
  Sentry.withScope((scope) => {
    if (options?.tags) {
      options.tags.forEach((tag) => scope.setTag(tag.key, tag.value))
    }
    if (options?.user?.id && options?.user?.email) {
      scope.setUser({ id: options.user.id, email: options.user.email })
    }
    if (options?.context) {
      scope.setContext('context', options.context)
    }
    if (options?.fingerprint) {
      scope.setFingerprint(options.fingerprint)
    }
    Sentry.captureException(error)
  })
}
